export default {
	meetingMap: {
		/*
		"12345678": {
			// flags
			hasActiveInitiatorEverJoinedMeeting: false,
			isCreatingTopicOutcome: false,
			isFetchingMeetingNote: false,
			isFinalizingMeeting: false,
			isJoiningMeeting: false,
			isMeetingInProgress: false,
			isMeetingNoteNew: false,
			isStartingMeeting: false,
			isStartingTopic: false,
			isStoppingMeeting: false,
			isUpdatingTopicOutcome: false,

			// state
			currentMeetingNote: "",
			meetingInitiator: "",
			pristineMeetingNote: "",
			startedTopicId: "",
			startTime: 0,
			stoppedTopicId: "",
			selectedTopicId: "",

			// maps
			meetingAttendanceMap: {},
			meetingAttendeeMap: {},
			topicStartMap: {},
			topicStartTimeMap: {},
		}
		*/
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/meeting/state.js